import { validationProvider } from '../../../../infrastructure/validation/validation.provider';
export class ReferenceTableItemEntity {
    constructor(properties) {
        this._id = validationProvider.validateAndTransformId(properties.id, {
            name: 'Reference Table Item ID',
            required: true,
        });
        this._attributes = validationProvider.validateAndTransformObject(properties.attributes, {
            name: 'Attributes',
            transformNullishToEmptyObject: true,
            transformPropertiesEmptyStringToNull: true,
        });
        this._tp2LookupTableItemId = validationProvider.validateAndTransformNumber(properties.tp2LookupTableItemId, {
            name: 'Tp2 Lookup Table Item Id',
        });
    }
    updateAttributes(attributes) {
        if (attributes) {
            this._attributes = {
                ...this._attributes,
                ...validationProvider.validateAndTransformObject(attributes, {
                    name: 'Attributes',
                    transformNullishToEmptyObject: true,
                    transformPropertiesEmptyStringToNull: true,
                }),
            };
        }
    }
    replaceAttributes(attributes) {
        this._attributes = validationProvider.validateAndTransformObject(attributes, {
            name: 'Attributes',
            transformNullishToEmptyObject: true,
            transformPropertiesEmptyStringToNull: true,
        });
    }
    get id() {
        return this._id;
    }
    get attributes() {
        return this._attributes;
    }
    get tp2LookupTableItemId() {
        return this._tp2LookupTableItemId;
    }
    set tp2LookupTableItemId(value) {
        this._tp2LookupTableItemId = value;
    }
}
//# sourceMappingURL=reference-table-item.entity.js.map